export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Residential Skip Hire',
      description: 'Perfect for home renovations, garden clean-ups, and decluttering projects in Johannesburg.',
      features: ['Same-day delivery', 'Flexible rental periods', 'All waste types accepted'],
      color: 'bg-orange-50'
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Skip Hire',
      description: 'Reliable waste management solutions for businesses, offices, and retail spaces.',
      features: ['Scheduled collections', 'Volume discounts', 'Professional service'],
      color: 'bg-orange-50'
    },
    {
      icon: 'ri-tools-line',
      title: 'Construction & Industrial Waste',
      description: 'Heavy-duty skips for building sites and large-scale construction projects.',
      features: ['Large capacity skips', 'Site waste management', 'Licensed disposal'],
      color: 'bg-orange-50'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <strong>Skip Hire Services</strong>
          </h2>
          <div className="w-16 h-1 bg-orange-500 mx-auto mb-4"></div>
          <p className="text-lg text-gray-600">
            Tailored <strong>waste management solutions</strong> for every project size in <strong>Johannesburg</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105 overflow-hidden cursor-pointer"
            >
              <div className={`${service.color} h-24 flex items-center justify-center`}>
                <i className={`${service.icon} text-5xl text-orange-500`} aria-label={service.title}></i>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3"><strong>{service.title}</strong></h3>
                <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-checkbox-circle-fill text-orange-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <a
                  href="https://wa.me/27844606965"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-orange-500 font-semibold hover:text-orange-600 transition-colors cursor-pointer inline-flex items-center"
                >
                  Learn More
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://wa.me/27844606965"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-3 border-2 border-orange-500 text-orange-500 font-semibold rounded-full hover:bg-orange-500 hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            View All Services
          </a>
        </div>
      </div>
    </section>
  );
}
